import React, { useState } from "react";
import classNames from "classnames/bind";
import { motion, AnimatePresence } from "framer-motion";

// components
import {
  FollowingList,
  NotificationList,
  SearchInput,
  SearchView,
  Tabs,
} from "../components";

// icons
import { CloseIcon, SearchIcon, ChevronRightIcon } from "src/assets/icons";

// data
import { followers, notifications } from "../data";

// variants
import {
  search_view_wrapper_variants,
  tab_content_variants,
  tab_variants,
} from "../data/variants";

import styles from "./Content.module.scss";
const cx = classNames.bind(styles);

const Content = ({ handleClose }) => {
  const [showInput, setShowInput] = useState(false);
  const [tabIndex, setTabIndex] = useState(2);

  const handleBtnClose = () => {
    if (!showInput) handleClose();
    else setShowInput(false);
  };

  return (
    <div className={cx("notification-root", { open: showInput })}>
      <span
        className={cx("btn-close", { select: showInput })}
        onClick={handleBtnClose}
      >
        {!showInput ? <CloseIcon /> : <ChevronRightIcon />}
      </span>
      <div className={cx("search-section")}>
        <SearchInput
          PreffixIcon={SearchIcon}
          isOpen={showInput}
          setIsOpen={setShowInput}
        />
      </div>
      <motion.div
        variants={tab_content_variants}
        animate={showInput ? "shrink" : "full"}
        transition={{ duration: 0.15 }}
        className={cx("content-section", { fixed: showInput })}
      >
        <Tabs index={tabIndex} setIndex={setTabIndex} />
        <div className={cx("content")}>
          <AnimatePresence exitBeforeEnter>
            <motion.div
              key={tabIndex}
              variants={tab_variants}
              initial="hidden"
              animate="visible"
              exit="exit"
              transition={{ duration: 0.15 }}
            >
              {tabIndex === 2 ? (
                <NotificationList data={notifications} />
              ) : (
                <FollowingList list={followers} />
              )}
            </motion.div>
          </AnimatePresence>
        </div>
      </motion.div>
      <AnimatePresence exitBeforeEnter>
        {showInput && (
          <motion.div
            variants={search_view_wrapper_variants}
            initial="hidden"
            animate="visible"
            exit="exit"
            className={cx("search-view-wrapper")}
          >
            <SearchView />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Content;
